import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Table } from "../../../components/SystemComponent/table";
import { GroupButton } from "../../../components/SystemComponent/GroupButton";
import { Badge } from "../../../components/SystemComponent/Bagde";
import { Button } from "../../../components/SystemComponent/Button";
import { MdAdd, MdEdit, MdDelete, MdEmail } from "react-icons/md";
import { createApi } from "../../../../core/api";

export const EmailTemplateList = () => {
  const api = useMemo(() => createApi(), []);
  const navigate = useNavigate();
  const { setPageMenus } = useOutletContext<any>();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const load = useCallback(() => {
    setLoading(true);
    api.emailTemplate
      .getAll()
      .then((r) => {
        if (r?.ok) {
          const list = r.data?.data ?? r.data ?? [];
          setData(Array.isArray(list) ? list : []);
        }
      })
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    setPageMenus([
      {
        label: "Email Templates",
        items: [
          { label: "Email Templates", route: "/dashboard/email-template" },
        ],
      },
    ]);
    load();
    return () => setPageMenus([]);
  }, [load, setPageMenus]);

  const doDelete = async () => {
    if (!deleteId) return;
    await api.emailTemplate.delete(deleteId);
    setDeleteId(null);
    load();
  };

  const columns = [
    { key: "id", title: "ID", minWidth: 60, accessor: (r: any) => r.id },
    {
      key: "code",
      title: "Code",
      minWidth: 200,
      accessor: (r: any) => r.code,
      render: (_: any, v: string) => (
        <Badge
          icon={MdEmail}
          label={v}
          color="#2563EB"
          bg="rgba(37,99,235,.15)"
        />
      ),
    },
    {
      key: "subject",
      title: "Subject",
      minWidth: 260,
      accessor: (r: any) => r.subject,
    },
    {
      key: "content",
      title: "Content",
      minWidth: 360,
      accessor: (r: any) => r.content,
      render: (_: any, v: string) =>
        v ? <div title={v}>{v.slice(0, 120)}...</div> : "-",
    },
    {
      key: "placeholders",
      title: "Placeholders",
      minWidth: 260,
      accessor: (r: any) => r.placeholders || "-",
    },
    {
      key: "actions",
      title: "Actions",
      minWidth: 160,
      render: (row: any) => (
        <GroupButton
          items={[
            {
              key: "edit-" + row.id,
              id: "edit",
              color: "#2563EB",
              icon: MdEdit,
              onClick: () =>
                navigate(`/dashboard/email-template/edit/${row.id}`),
            },
            {
              key: "delete-" + row.id,
              color: "#DC2626",
              id: "delete",
              icon: MdDelete,
              onClick: () => setDeleteId(row.id),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Email Templates</div>
          <div style={{ fontSize: 13, color: "#64748B" }}>
            Manage system email templates
          </div>
        </div>

        <Button
          icon={MdAdd}
          onClick={() => navigate("/dashboard/email-template/edit/0")}
        >
          Create Template
        </Button>
      </div>

      <Table
        tableKey="email-template-v2"
        loading={loading}
        columns={columns}
        data={data}
        features={{
          sortable: true,
          filterable: true,
          pagination: true,
          pivot: false,
          excel: false,
          columnReorder: false,
        }}
      />

      {deleteId && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 24,
              borderRadius: 12,
              minWidth: 320,
            }}
          >
            <div style={{ fontWeight: 700 }}>Delete Email Template?</div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 12,
                marginTop: 16,
              }}
            >
              <Button variant="ghost" onClick={() => setDeleteId(null)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={doDelete}>
                Delete
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
